// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"7328d116","547":"a6c810a0"}[chunkId] + ".chunk.js";
};